<template>
  <v-container class="py-0" fluid>
    <v-row align="center">
      <v-col class="py-1 px-0">
        <v-checkbox
          v-for="(athletic, index) in athleticEvents"
          :key="index"
          v-model="selectedAthleticEventlIds"
          :label="athletic.name"
          :value="athletic.id"
          color="secondary"
          hide-details
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    athleticEvents() {
      return this.$store.state.master.allAthleticEvents
    },

    selectedAthleticEventlIds: {
      get() {
        return this.$store.state.top.currentSubjectCondition.selectedAthleticEvents.map(athleticEvent => athleticEvent.id)
      },
      set(values) {
        this.$store.commit(
          'changeCurrentSubjectCondition',
          { selectedAthleticEvents: this.athleticEvents.filter(athleticEvent => values.includes(athleticEvent.id)) }
        )
      }
    },
 },
}
</script>

<style lang="stylus" scoped>
  .choice-athletic-event
    display flex
    height 106px

    &__checkbox
      margin-top: 22px;

  .v-label
    font-weight bold
</style>
